import { render, staticRenderFns } from "./StartedGuide.vue?vue&type=template&id=6ff8ae0a&scoped=true&"
import script from "./StartedGuide.vue?vue&type=script&lang=js&"
export * from "./StartedGuide.vue?vue&type=script&lang=js&"
import style0 from "./StartedGuide.vue?vue&type=style&index=0&id=6ff8ae0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8ae0a",
  null
  
)

export default component.exports